import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './Store/store';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import AuthProvider from 'react-auth-kit';
import { ThemeContextProvider } from './Themes/ThemeContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <Provider store={store}>
        <ThemeContextProvider>
        <LocalizationProvider adapterLocale='en' dateAdapter={AdapterLuxon}>
          <App />
        </LocalizationProvider>
        </ThemeContextProvider>
      </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
